<template>
    <headroom class="vue-headroom-wrapper" :offset="400" @unpin="handleUnpin" :disabled="true">
        <slot></slot>

        <slot name="mega-menu"></slot>
    </headroom>
</template>

<script>
import { headroom } from 'vue-headroom';

export default {
    name: "HeadroomWrapper",

    props: ['eventBus'],

    components: {
        headroom
    },

    computed: {
        isFrontPage() {
            return document.body.classList.contains('page-node-type-homepage');
        }
    },

    mounted() {
        let dropdownToggler = this.$el.querySelector('.block-dropdown-language');

        if (_.isNil(dropdownToggler)) {
            return;
        }

        setTimeout(() => {
            dropdownToggler.classList.add('d-block');
        }, 100);
    },

    methods: {
        handleUnpin() {
            document.body.classList.remove('main-menu-active');
            document.getElementById('menu-toggle').classList.remove('active');

            this.eventBus.$emit('open-mega-menu', false);
        }
    }
}
</script>
